import { Component, OnInit, EventEmitter, Output, ChangeDetectorRef, ViewChild, HostListener, AfterViewInit, ElementRef } from '@angular/core';
import { RackLocationPipe } from '../../helpers/rackLocation.pipe';
import { MessageService } from 'primeng/api';
import { RackDataService } from '../../data-services/rack.service';
import { RequisitionExceptionDataService } from '../../data-services/requisitionException.service';
import { LookupService } from '../../data-services/lookup.service';
import { RequisitionDataService } from "../../data-services/requisition.service";
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { BlockUIModule } from 'primeng/blockui';
import { ScrollerModule } from 'primeng/scroller';

@Component({
  selector: 'app-resolve-load-rack',
  templateUrl: './rack.load.html',
  providers: [MessageService],
  imports: [ButtonModule, Dialog, FormsModule, Toast, CommonModule, SelectModule, DatePickerModule, BlockUIModule, RackLocationPipe, ScrollerModule]
})
export class RackLoadComponent implements OnInit, AfterViewInit {

  constructor(private rackDataService: RackDataService,
    private requisitionExceptionService: RequisitionExceptionDataService,
    private lookupService: LookupService,
    private rackLocationPipe: RackLocationPipe,
    private messageService: MessageService,
    private requisitionService: RequisitionDataService
  ) {
  }
  loading: boolean = false;
  trackingId: string = "";
  rack: any = {};
  requisition: any = {};
  emptyRack: any = {};
  rackFound: boolean = false;
  rackTypes: any[];
  departments: any[];
  searchTrackingHelpText: string = "";
  showCantLoadDialog: boolean = false;
  showNewRackDialog: boolean = false;
  cantLoad: boolean = false;
  loadMessage: string = "";
  dialogHeading: string = "";
  emptyRow: number = 0;
  emptyCol: number = 0;
  rackIsFull: boolean = false;
  minDateValue: Date = new Date(new Date().setFullYear(new Date().getFullYear() - 105));
  maxDateValue: Date = new Date();
  columnName: string[] = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];


  @ViewChild('searchTracking') searchElement: ElementRef;
  @Output() onCompleted = new EventEmitter<boolean>();

  ngOnInit() {
    this.rackDataService.getEmptyModel().subscribe((data: any) => {
      this.emptyRack = data;
    });

    this.rackDataService.getRackTypes().subscribe((data: any) => {
      this.rackTypes = data.map(d => <any>{ name: d.Name, code: d.Code });
    });

    this.lookupService.getDepartments().subscribe((data: any) => {
      this.departments = data.map(d => <any>{ name: d.Name, code: d.Id });
    });
    this.searchTrackingHelpText = "Scan the rack serial number";
  }

  ngAfterViewInit() {
    this.searchElement.nativeElement.focus();
  }

  public close() {
    this.onCompleted.emit(false);
  }

  public cancel() {
    this.trackingId = "";
  }

  //Barcode scanning/entry handling
  barcode = "";
  barcodeReading = false;

  @HostListener('document:keypress', ['$event'])
  handleScannerInput(event) {
    this.handleKeystroke(event.keyCode, event.key);
  }

  handleKeystroke(keyCode, key) {
    //usually scanners throw an 'Enter' key at the end of read
    if (keyCode === 13) {
      this.handleBarCode(this.barcode);
      this.barcode = "";
    } else {
      this.barcode += key;//while this is not an 'enter' it stores the every key            
    }

    //run a timeout of 200ms at the first read and clear everything
    if (!this.barcodeReading) {
      this.barcodeReading = true;
      setTimeout(() => {
        this.barcode = "";
        this.barcodeReading = false;
      }, 200);
    }
  }

  handleBarCode(code: string) {
    var id = code.replace(/[^ -~]+/g, ""); //remove nondisplayable characters
    if (!id) {
      return;
    }
    id = id.toUpperCase().trim();
    if (this.rack.Id) {
      this.loadAccession(id);
    } else {
      this.loadRack(id);
    }
    this.trackingId = "";
  }

  public handleSearchButton() {
    this.handleBarCode(this.trackingId);
  }

  private loadRack(trackingId: string) {
    this.loading = true;
    this.showNewRackDialog = false;
    this.clearCell();
    this.rackDataService.getBySerialNumber(trackingId).subscribe((data: boolean) => {
      if (data) {
        this.rack = data;
        this.rack.Contents = this.rack.Contents.sort((n1, n2) => {
          if (n1.Row > n2.Row) return 1;
          if (n1.Row < n2.Row) return -1;
          if (n1.row == n2.Row && n1.Col > n2.Col) return 1;
          if (n1.row == n2.Row && n1.Col < n2.Col) return -1;
          return 0;
        });
        this.findEmptyCell();
        this.loading = false;
        this.searchTrackingHelpText = "Scan the sample";
      }
      else {
        this.rack = this.emptyRack;
        this.rack.SerialNumber = trackingId;
        this.showNewRackDialog = true;
        this.loading = false;
        this.searchTrackingHelpText = "Scan the rack serial number";
      }
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Load Rack', detail: 'Error looking for Serial Number: ' + trackingId, life: 6000, closable: true, sticky: true });
        this.loading = false;
        this.searchTrackingHelpText = "Scan the rack serial number";
      });
  }

  private loadAccession(trackingId: string) {
    this.showCantLoadDialog = false;
    this.loading = true;

    this.requisitionExceptionService.getRequisitionByAccession(trackingId).subscribe((data: boolean) => {
      if (!data) {
        this.requisition = {};
        this.requisition.Accession = trackingId;
        this.loading = false;
        this.loadMessage = "This Sample has not been received. It is unknown and cannot be added to rack. ";
        this.dialogHeading = `Accession ${trackingId}`;
        this.cantLoad = true;
        this.showCantLoadDialog = true;
        this.loading = false;
        return;
      }
      
      this.requisition = data;
      var cell = this.rack.Contents.find(r => r.RequisitionId == this.requisition.Id);
      if (cell) {
        this.loadMessage = `This Sample is already located in this rack at position ${this.rackLocationPipe.transform(cell.Row, cell.Col)} have Exceptions, can't add to rack`;
        this.dialogHeading = `Accession ${trackingId}`;
        this.cantLoad = true;
        this.showCantLoadDialog = true;
        this.loading = false;
        return;
      }

      this.requisitionService.getDetail(this.requisition.Id).subscribe((data: any) => {
        if (!data.RequisitionExceptions) {
          this.loadMessage = "This Sample does NOT have Exceptions, can't add to rack";
          this.dialogHeading = "Accession " + trackingId;
          this.cantLoad = true;
          this.showCantLoadDialog = true;
          this.loading = false;
          return;
        }
      });

      

      if (this.rackIsFull) {
        this.dialogHeading = "Accession " + trackingId;
        this.loadMessage = "The Rack is full";
        this.cantLoad = true;
        this.showCantLoadDialog = true;
        this.loading = false;
        return;
      }

      if (this.emptyCol < 1 || this.emptyRow < 1) {
        this.findEmptyCell();
      }
      this.cantLoad = false; 
      this.loadMessage = "Put the sample in " + this.rackLocationPipe.transform(this.emptyRow, this.emptyCol) ;
      this.dialogHeading = "Accession " + trackingId;
      this.showCantLoadDialog = true;
      this.loading = false;
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Load Rack', detail: 'Error looking for Accession: ' + trackingId, life: 6000, closable: true, sticky: true });
        this.loading = false;
      });
  }

  public addRack() {
    this.loading = true;
    this.rack.DepartmentId = this.rack.DepartmentId.code;
    this.rack.RackTypeCode = this.rack.RackTypeCode.code;
    this.rackDataService.saveRack(this.rack).subscribe((data: boolean) => {
      this.rackDataService.getBySerialNumber(this.rack.SerialNumber).subscribe((data: boolean) => {
        if (data) {
          this.rack = data;
          this.findEmptyCell();
          this.loading = false;
          this.showNewRackDialog = false;
        }
        else {
          this.clearCell();
          this.messageService.add({ severity: 'error', summary: 'Load Rack', detail: 'Error loading Rack for Serial Number: ' + this.rack.SerialNumber, life: 6000, closable: true, sticky: true });
          this.loading = false;
          this.showNewRackDialog = false;
        }
      },
        (err) => {
          this.clearCell();
          this.messageService.add({ severity: 'error', summary: 'Load Rack', detail: 'Error loading Rack for Serial Number: ' + this.rack.SerialNumber, life: 6000, closable: true, sticky: true });
          this.loading = false;
        });
    },
      (err) => {
        this.clearCell();
        this.messageService.add({ severity: 'error', summary: 'Load Rack', detail: 'Error saving Rack for Serial Number: ' + this.rack.SerialNumber, life: 6000, closable: true, sticky: true });
        this.loading = false;
      });
  }

  private findEmptyCell() {
    this.emptyRow = -1;
    this.emptyCol = -1;
    for (let y = 1; y <= this.rack.RackType.Rows; y++) {
      for (let x = 1; x <= this.rack.RackType.Cols; x++) {
        var cell = this.rack.Contents.find(r => r.Row == y && r.Col == x);
        if(!cell) {
          this.emptyRow = y;
          this.emptyCol = x;
          this.rackIsFull = false;
          return;
        }
      }
    }
    this.rackIsFull = true;
  }

  public clearCell() {
    this.requisition = {};
    this.emptyRow = -1;
    this.emptyCol = -1;
    this.showCantLoadDialog = false;
  }

  public changeRack() {
    this.rack = {};
    this.requisition = {};
    this.rackIsFull = false;
    this.emptyRow = -1;
    this.emptyCol = -1;
    this.showCantLoadDialog = false;
    this.searchTrackingHelpText = "Scan the rack serial number";
  }

  public saveLocation() {
    this.loading = true;
    var dto: any = {};
    dto.RackId = this.rack.Id;
    dto.RequisitionId = this.requisition.Id;
    dto.Row = this.emptyRow;
    dto.Col = this.emptyCol;
    dto.AddOrRemove = "A";
    dto.FirstName = this.requisition.FirstName;
    dto.LastName = this.requisition.LastName;
    dto.BirthDate = this.requisition.BirthDate;

    this.rackDataService.saveRequisitionLocation(dto).subscribe((data: boolean) => {
      dto.Id = 0;
      dto.Accession = this.requisition.Accession;
      dto.LastName = this.requisition.LastName;
      dto.Firstname = this.requisition.FirstName;
      dto.AddedDate = new Date();
      dto.StatusValue = this.requisition.StatusValue;
      dto.StatusText = this.requisition.StatusText;
      this.rack.Contents.push(dto);
      this.rack.Contents = this.rack.Contents.filter(x => x.RequisitionId != -1).sort((n1, n2) => {
        if (n1.Row > n2.Row) return 1;
        if (n1.Row < n2.Row) return -1;
        if (n1.row == n2.Row && n1.Col > n2.Col) return 1;
        if (n1.row == n2.Row && n1.Col < n2.Col) return -1;
        return 0;
      });
      this.findEmptyCell();
      this.showCantLoadDialog = false;
      this.loading = false;
    },
      (err) => {
        this.showCantLoadDialog = false;
        this.messageService.add({ severity: 'error', summary: 'Save Rack Location', detail: 'Error saving requisition in rack location. Accession: ' + this.requisition.Accession, life: 6000, closable: true, sticky: true });
        this.findEmptyCell();
        this.loading = false;
      });
  }

  public getColor(x, y) {
    var cell = this.rack.Contents.find(r => r.Row == x+1 && r.Col == y+1);
    if (cell) {
      if (cell.StatusText == "Exceptions") return "#ffe38e"
      if (cell.StatusText == "Rejected") return "#dc3545"
      return "#8DC8B5";
    }
    return "lightgrey";
  }

  public getAccession(x, y) {
    var cell = this.rack.Contents.find(r => r.Row == x+1 && r.Col == y+1);
    if (cell) {
      return cell.Accession;
    }
    return "";
  }

  public removeToast() {
    this.messageService.clear();
  }
}  
